import { render, staticRenderFns } from "./LogAccessi.vue?vue&type=template&id=54ed1b36&scoped=true"
import script from "./LogAccessi.vue?vue&type=script&lang=js"
export * from "./LogAccessi.vue?vue&type=script&lang=js"
import style0 from "./LogAccessi.vue?vue&type=style&index=0&id=54ed1b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed1b36",
  null
  
)

export default component.exports